import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { TimetableRoutingComponent } from './components/timetable-routing/timetable-routing.component';
import { TimetableSearchGuard } from './guards/timetable-search.guard';

export const timetableRoutes: Routes = [
  {
    path: '',
    component: TimetableRoutingComponent,
    children: [],
    canActivate: [TimetableSearchGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(timetableRoutes)],
  declarations: [],
  providers: [],
  exports: [RouterModule],
})
export class TimetableRoutesModule {}
